import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gg-drag-and-drop-icon',
  templateUrl: './drag-and-drop-icon.component.html',
  styleUrls: ['./drag-and-drop-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DragAndDropIconComponent {}
